<template>
  <div class="mx-2 mb-2">
    <b-row>
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-start"
      >
        <span class="text-muted text-capitalize">{{
          $t("table.showing", {
            from: dataMeta.from,
            to: dataMeta.to,
            of: dataMeta.of,
          })
        }}</span>
      </b-col>
      <!-- Pagination -->
      <b-col
        cols="12"
        sm="6"
        class="d-flex align-items-center justify-content-center justify-content-sm-end"
      >
        <Pagination
          :totalList="totalList"
          :currentPage="currentPage"
          @updatePagination="updatePagination"
          :perPage="perPage"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import Pagination from "@/components/Pagination.vue";

export default {
  name: "TableFooter",
  components: {
    BRow,
    BCol,
    Pagination,
  },
  props: {
    dataMeta: {
      type: Object,
      required: true,
      validator: (value) => {
        return (
          typeof value.from === "number" &&
          typeof value.to === "number" &&
          typeof value.of === "number"
        );
      },
    },
    totalList: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
  },
  methods: {
    updatePagination(page) {
      this.$emit("updatePagination", page);
    },
  },
};
</script>
